"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDotMargin = void 0;
const getDotMargin = ({
  isActive = false,
  isNext = false,
  isPrevious = false
} = {}) => {
  if (isActive) {
    return '0px';
  } else if (isNext || isPrevious) {
    return '3px';
  }
  return '1px';
};
exports.getDotMargin = getDotMargin;
//# sourceMappingURL=getDotMargin.js.map